import { TabList } from '@headlessui/react'
import React from 'react'
import { twMerge } from 'tailwind-merge'

interface PageTabListProps extends Record<string, unknown> {
  className?: string
  buttonBar?: React.ReactNode
}

export const PageTabList = ({ className, buttonBar, ...props }: PageTabListProps) => {
  return (
    <div
      className={twMerge(
        'mb-5 ml-[min(-20px,calc(-1*(100vw-1536px)/2-20px))] flex w-screen items-center justify-between bg-background-secondary pl-[max(20px,calc((100vw-1536px)/2+20px))] pr-10 lg:pr-[max(20px,calc((100vw-1536px)/2+20px))]',
        className,
      )}
    >
      <TabList {...props} />
      {buttonBar}
    </div>
  )
}
